/**
 * Attempts to launch the SIKI mobile app using custom URL scheme
 * Returns true if app launch was attempted, false otherwise
 */
export const tryLaunchApp = (currentPath) => {
  // Get the current full URL path
  const fullPath = currentPath || window.location.pathname + window.location.search;

  // Convert https://staging.siki.io/path to siki://staging.siki.io/path
  const customSchemeUrl = `siki://${window.location.hostname}${fullPath}`;

  console.log('[App Launcher] Attempting to launch app with:', customSchemeUrl);

  // Create a hidden iframe to attempt app launch
  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.src = customSchemeUrl;
  document.body.appendChild(iframe);

  // Clean up iframe after attempt
  setTimeout(() => {
    document.body.removeChild(iframe);
  }, 2000);

  // Also try direct window.location as fallback
  setTimeout(() => {
    window.location.href = customSchemeUrl;
  }, 100);

  return true;
};

/**
 * Checks if we should attempt to launch the app for this URL
 */
export const shouldAttemptAppLaunch = () => {
  // Respect the web-app bypass — allowlisted users opted into the browser experience
  try { if (localStorage.getItem('bypassMobileLanding')) return false; } catch (e) {}

  const path = window.location.pathname;

  // List of paths that should try to open in the app
  const appPaths = [
    '/app/',
    '/ArtistProfile/',
    '/SongDetails/',
    '/SongDetail/',
    '/Music/',
    '/LiveVideoStreaming/',
    '/s/',
    '/l/'
  ];

  return appPaths.some(p => path.includes(p));
};
